import {ListType} from "../../definitions/types";

export class ListModel {
    private readonly _id: number;
    private readonly _name?: string;
    private readonly _path: string;

    constructor(listType: ListType) {
        this._id = listType.id;
        this._name = listType.name;
        this._path = listType.path;
    }

    /**
     * @property id
     * @description The list id.
     * @returns {string}
     */
    public get id(): number {
        return this._id;
    }

    /**
     * @property name
     * @description The list name.
     * @returns {string | undefined}
     */
    public get name(): string | undefined {
        return this._name;
    }

    /**
     * @property path
     * @description The list path.
     * @returns {string}
     */
    public get path(): string {
        return this._path;
    }
}